'use strict';

var ScheduleChangeConstants = {
  ENTITIES: {
    MARKETS: 'markets',
    LEGS: 'legs',
    FLIGHTS: 'flights'
  },
  TYPE: {
    MARKETS: {
      type: 'Market'
    },
    FLIGHTS: {
      type: 'Flight'
    }
  }
};
module.exports = ScheduleChangeConstants;